module.exports = __webpack_public_path__ + "img/form.c1bf451.svg";